import { render, staticRenderFns } from "./ItemSearchCategorySelector.vue?vue&type=template&id=217551cc&scoped=true&"
import script from "./ItemSearchCategorySelector.vue?vue&type=script&lang=ts&"
export * from "./ItemSearchCategorySelector.vue?vue&type=script&lang=ts&"
import style0 from "./ItemSearchCategorySelector.vue?vue&type=style&index=0&id=217551cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217551cc",
  null
  
)

export default component.exports